import React, { memo } from 'react'
import dynamic from 'next/dynamic'
import { FormattedMessage, useIntl } from 'react-intl'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'
import AccordionVDP from 'components/common/AccordionVDP'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import useMediaQuery from '@mui/material/useMediaQuery'
import Swiper from 'components/common/Swiper'
import { useRouter } from 'next/router'
import sx from './styles'

const MapDynamic = dynamic(() => import('components/shared/Map'), { ssr: false })

const BranchItem = ({ branch }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const router = useRouter()
  const { formatMessage: f } = useIntl()
  const whatsappMessageAgencias = 'Hola, necesito información.'

  const handleRedirectToSrp = (path) => {
    router.push(f({ id: path }))
  }

  const staging = process.env.NEXT_PUBLIC_BASE_URL !== 'https://clikauto.com'

  return (
    <>
      <AccordionVDP
        title={branch?.branchName}
        setTitleBlackColor
        isValid
        IsValidIcon
        arrowsIcon
        sx={sx.accordionVDP}
      >
        <Box>
          <Box sx={sx.scheduleContainer}>

            {branch?.schedule?.week && (
              <>
                <Typography
                  variant="subtitle1"
                >
                  <FormattedMessage id="BRANCHES_SCHEDULE_WEEK" />
                </Typography>
                <Typography
                  sx={sx.dateItem}
                >
                  {branch?.schedule?.week}
                </Typography>
              </>
            )}

            {branch?.schedule?.saturday && (
              <>
                <Typography
                  variant="subtitle1"
                  sx={sx.dateItem}
                >
                  <FormattedMessage id="BRANCHES_SCHEDULE_SAT" />
                </Typography>
                <Typography sx={sx.dateItem}>
                  {branch?.schedule?.saturday}
                </Typography>
              </>
            )}

            {branch?.schedule?.sunday && (
              <>
                <Typography
                  variant="subtitle1"
                  sx={sx.dateItem}
                >
                  <FormattedMessage id="BRANCHES_SCHEDULE_SUN" />
                </Typography>
                <Typography sx={sx.dateItem}>
                  {branch?.schedule?.sunday}
                </Typography>
              </>
            )}

          </Box>

          <Box>
            <Typography
              variant="link-text"
              target="_blank"
              component="a"
              rel="noreferrer"
              href={branch?.address?.link}
            >
              {f({ id: `${branch?.address?.text}` })}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption">
              {branch?.schedule?.disclaimer}
            </Typography>
          </Box>
        </Box>

        <Grid
          container
          sx={sx.btnsContainers}
        >

          {(branch?.srp_path_staging || branch?.srp_path) && (
            <Grid
              size={{
                xs: 6,
                md: 3,
              }}
              p={1}
            >
              <Button
                fullWidth
                variant="outlined"
                sx={sx.btn}
                onClick={() => handleRedirectToSrp(`${staging ? branch?.srp_path_staging : branch?.srp_path}`)}
              >
                <FormattedMessage id="SHOW_VEHICLES_CTA" />
              </Button>
            </Grid>
          )}

          <Grid
            size={{
              xs: 6,
              md: 3,
            }}
            p={1}
          >
            <Typography
              variant="subtitle2"
              target="_blank"
              component="a"
              rel="noreferrer"
              href={branch?.address?.link}
            >
              <Button
                fullWidth
                variant="outlined"
                sx={sx.btn}
              >
                <FormattedMessage id="SHOW_MAP_CTA" />
              </Button>
            </Typography>
          </Grid>
          {
            (!isMobile) && (
              <>

                {branch?.whatsapp && (
                  <Grid
                    size={{
                      xs: 6,
                      md: 3,
                    }}
                    p={1}
                  >
                    <Typography
                      sx={sx.whatsLink}
                      variant="subtitle2"
                      component="a"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`//wa.me/${branch?.whatsapp}?text=${whatsappMessageAgencias}`}
                    >
                      <Button
                        fullWidth
                        variant="outlined"
                        sx={sx.btn}
                      >
                        <FormattedMessage
                          id="SEND_US_A_MESSAGE_CTA"
                        />
                      </Button>
                    </Typography>
                  </Grid>
                )}

                {branch?.phone_number && (
                  <Grid
                    size={{
                      xs: 6,
                      md: 3,
                    }}
                    p={1}
                  >
                    <Typography
                      sx={sx.whatsLink}
                      variant="subtitle2"
                      component="a"
                      rel="noreferrer"
                      href={isMobile ? `tel:${branch?.phone_number}` : '#'}
                    >

                      <Button
                        fullWidth
                        variant="outlined"
                        sx={sx.btn}
                      >
                        <FormattedMessage
                          id="CALL_US_CTA"
                          values={{ number: branch?.phone_number }}
                        />
                      </Button>
                    </Typography>
                  </Grid>
                )}

              </>
            )
          }
        </Grid>

        <Grid container>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <MapDynamic
              location={{
                lat: parseFloat(branch?.address.latitude),
                lng: parseFloat(branch?.address.longitude),
              }}
              zoomLevel={16}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
            sx={sx.imageSwiper}
          >
            <Swiper
              items={branch?.photos}
              prefixIds="banners"
            />
          </Grid>

        </Grid>
        {
          isMobile && (
            <>

              {branch?.whatsapp && (
                <Grid size={12}>
                  <Typography
                    sx={sx.whatsLink}
                    variant="subtitle2"
                    component="a"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`//wa.me/${branch?.whatsapp}?text=${whatsappMessageAgencias}`}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      sx={sx.btn}
                    >
                      <FormattedMessage
                        id="SEND_US_A_MESSAGE_CTA"
                      />
                    </Button>
                  </Typography>
                </Grid>
              )}

              {branch?.phone_number && (
                <Grid size={12}>
                  <Typography
                    sx={sx.whatsLink}
                    variant="subtitle2"
                    component="a"
                    rel="noreferrer"
                    href={isMobile ? `tel:${branch?.phone_number}` : '#'}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      sx={sx.btn}
                    >
                      <FormattedMessage
                        id="CALL_US_CTA"
                        values={{ number: branch?.phone_number }}
                      />
                    </Button>
                  </Typography>
                </Grid>
              )}

            </>
          )
        }
      </AccordionVDP>
    </>
  )
}

export default memo(BranchItem)
